import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="col-span-1">
            <div className="flex items-center mb-3">
              <img src="/logo.svg" alt="VGBComputers Logo" className="h-10 w-10 mr-2" />
              <span className="text-2xl font-bold text-white">VGBComputers</span>
            </div>
            <p className="mt-2 text-gray-400 text-center italic font-medium">
              Tu socio tecnológico integral en Tenerife
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Enlaces Rápidos</h2>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/sobre-nosotros" className="text-gray-400 hover:text-white">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Contacto</h2>
            <ul className="space-y-2">
              <li className="flex items-center">
                <SafeIcon icon={FiIcons.FiBriefcase} className="mr-2" />
                <span className="text-gray-400">VGBComputers</span>
              </li>
              <li className="flex items-center">
                <div className="text-red-500 mr-2 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-6">
                    <path d="M12 0C7.31 0 3.5 3.81 3.5 8.5c0 5.94 7.03 14.15 7.81 15.09.39.47 1.02.47 1.41 0 .78-.94 7.78-9.15 7.78-15.09C20.5 3.81 16.69 0 12 0zm0 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                  </svg>
                </div>
                <a
                  href="https://maps.app.goo.gl/jT6LFzR59caoLysh7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white"
                >
                  C.C. Nuestra Señora de África, Local 64 - Santa Cruz de Tenerife
                </a>
              </li>
              <li className="flex items-center">
                <SafeIcon icon={FiIcons.FiPhone} className="mr-2" />
                <a href="https://wa.me/34922640256" className="text-gray-400 hover:text-white">
                  <span>+34 922 640 256</span>
                </a>
              </li>
              <li className="flex items-center">
                <SafeIcon icon={FiIcons.FiMail} className="mr-2" />
                <a href="mailto:info@vgbcomputers.com" className="text-gray-400 hover:text-white">
                  info@vgbcomputers.com
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Síguenos</h2>
            <div className="flex space-x-4">
              <a
                href="https://es.linkedin.com/in/vgbcomputers"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiIcons.FiLinkedin} className="h-6 w-6" />
              </a>
              <a
                href="http://x.com/vgbcomputers"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiIcons.FiTwitter} className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/vgbcomputers"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiIcons.FiFacebook} className="h-6 w-6" />
              </a>
              <a
                href="https://instagram.com/vgbcomputers"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiIcons.FiInstagram} className="h-6 w-6" />
              </a>
              <a
                href="https://www.youtube.com/vgbcomputers"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiIcons.FiYoutube} className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400">
              © {new Date().getFullYear()} VGBComputers. Todos los derechos reservados.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link to="/aviso-legal" className="text-gray-400 hover:text-white">
                Aviso Legal
              </Link>
              <Link to="/privacidad" className="text-gray-400 hover:text-white">
                Política de Privacidad
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white">
                Política de Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;